import { render } from "./MyCustomerOrder.vue?vue&type=template&id=47065db6&scoped=true"
import script from "./MyCustomerOrder.vue?vue&type=script&lang=js"
export * from "./MyCustomerOrder.vue?vue&type=script&lang=js"

import "./MyCustomerOrder.vue?vue&type=style&index=0&id=47065db6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47065db6"]])

export default __exports__